import React, { useState, useCallback } from "react";
import { Row, Col, Typography } from "antd";
import { useIntl } from "react-intl";

import ProductSelect from "./productSelect";
import LoadError from "../../app/generic/loadError";
import LoadSkeleton from "../../app/generic/loadSkeleton";
import TooltipButton from "../../app/generic/tooltipButton";

const { Title } = Typography;

function ProductChoice({ onProductClick, productGroups, onLoadProducts }) {
  const intl = useIntl();
  const [selectedProduct, setSelectedProduct] = useState();
  const handleProductSelect = useCallback((product) => {
    setSelectedProduct(product);
  }, []);

  const handleContinue = useCallback(() => {
    onProductClick(selectedProduct);
  }, [onProductClick, selectedProduct]);

  return (
    <Row
      type="flex"
      align="middle"
      justify="center"
      gutter={[0, 100]}
      className="product-choice"
    >
      <Col span={24} className="center">
        {productGroups ? (
          productGroups === "e" ? (
            <LoadError
              message={intl.formatMessage({
                id: "consignment.product.loadError",
                defaultMessage: "Při načítání produktů nastala chyba.",
              })}
              onClick={onLoadProducts}
            />
          ) : (
            <Row type="flex" align="middle" className="product-choice-form-row">
              <Col span={12}>
                <Row type="flex" align="middle" justify="space-around">
                  <Col span={18}>
                    <ProductSelect
                      productGroups={productGroups}
                      selectedProduct={selectedProduct}
                      onProductSelect={handleProductSelect}
                    />
                  </Col>
                  <Col span={6}>
                    <TooltipButton
                      text={intl.formatMessage({
                        id: "messages.continue",
                        defaultMessage: "Pokračovat",
                      })}
                      onClick={handleContinue}
                      disabled={!selectedProduct}
                      className="product-choice-button"
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                {!selectedProduct && (
                  <Title level={4}>
                    {intl.formatMessage({
                      id: "consignment.product.chooseProduct",
                      defaultMessage: "Pro pokračování vyberte produkt.",
                    })}
                  </Title>
                )}
              </Col>
            </Row>
          )
        ) : (
          <LoadSkeleton />
        )}
      </Col>
    </Row>
  );
}

export default ProductChoice;
